export const LOGGED_USER = 'LOGGED_USER';
export const FETCH_LOGGED_USER = 'FETCH_LOGGED_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_USER = 'SET_USER';
